export enum EMealKind {
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	ADDON = 'addon',
}

export enum EMealDialogType {
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	ADDON_MEAL = 'addon_meal',
	ADDON_MEAL_PREP = 'addon_prep_meal',
}

export enum EMealType {
	BREAKFAST = 'breakfast',
	SECOND_BREAKFAST = 'second_breakfast',
	LUNCH = 'lunch',
	AFTERNOON_SNACK = 'afternoon_snack',
	DINNER = 'dinner',
}

export const MealTypeMap: Record<EMealType, string> = {
	[EMealType.BREAKFAST]: 'Śniadanie',
	[EMealType.SECOND_BREAKFAST]: 'Drugie śniadanie',
	[EMealType.LUNCH]: 'Obiad',
	[EMealType.AFTERNOON_SNACK]: 'Podwieczorek',
	[EMealType.DINNER]: 'Kolacja',
}

export const MealTypesSelect = generateSelectOptions(EMealType, MealTypeMap)

export const MealTypeSortOrder: EMealType[] = [
	EMealType.BREAKFAST,
	EMealType.SECOND_BREAKFAST,
	EMealType.LUNCH,
	EMealType.AFTERNOON_SNACK,
	EMealType.DINNER,
]

export enum EMealTabs {
	DETAILS_INFO = 'details_info',
	INGRIDIENTS_AND_VARIANTS = 'ingridients_and_variants',
	PRODUCTION_STEPS = 'production_steps',
}

export const MealOrder = [
	EMealType.BREAKFAST,
	EMealType.SECOND_BREAKFAST,
	EMealType.LUNCH,
	EMealType.AFTERNOON_SNACK,
	EMealType.DINNER,
] as const

export enum EDietMealComponentType {
	SEMIPRODUCT = 'dietary_semi_product',
	MATERIAL = 'dietary_raw_material',
	GROUP = 'dietary_group',
}

export enum EMealCategory {
	MEAL = 'meal',
	MEALPREP = 'prep_meal',
	ADDON = 'addon',
}
